import React from "react";
import {
  ShieldCheck,
  Settings,
  Truck,
  Clock,
  BadgeCheck,
  Users,
  Star,
  Wrench,
  Building,
  ThumbsUp
} from "lucide-react";

const cards = [
  {
    type: "intro",
    icon: <BadgeCheck size={40} />,
    heading: "Why Choose Us",
    description:
      "",
  },
  {
    icon: <ShieldCheck size={24} />,
    label: "Trusted Systems",
    title: "Reliable & Secure",
    description: "We deliver certified systems built for long-term safety and performance.",
  },
  {
    icon: <Settings size={24} />,
    label: "Engineering Expertise",
    title: "Custom Solutions",
    description: "Tailor-made parking systems for residential, commercial, or mixed-use.",
  },
  {
    icon: <Truck size={24} />,
    label: "Turnkey Execution",
    title: "End-to-End Service",
    description: "From design to delivery and post-installation support, we do it all.",
  },
  {
    icon: <Clock size={24} />,
    label: "Timely Delivery",
    title: "Fast & Efficient",
    description: "We ensure quick installations without compromising on quality.",
  },
  {
    icon: <Users size={24} />,
    label: "Professional Team",
    title: "Expert Workforce",
    description: "Skilled professionals ensure error-free design, planning and execution.",
  },
];

const WhyChooseUs = () => {
  return (
    <section className="lt-chooseus-wrapper">
      {cards.map((card, index) => (
        <div
          key={index}
          className={`lt-chooseus-card lt-card-${index} ${
            card.type === "intro" ? "lt-intro-card" : ""
          }`}
        >
          <div className="lt-card-icon-wrapper">
            <div className="lt-card-icon">{card.icon}</div>
          </div>
          {card.type === "intro" ? (
            <>
              <h2 className="lt-intro-heading">{card.heading}</h2>
              <p className="lt-intro-description">{card.description}</p>
            </>
          ) : (
            <>
              <p className="lt-card-label">{card.label}</p>
              <h3 className="lt-card-title">{card.title}</h3>
              <p className="lt-card-description">{card.description}</p>
            </>
          )}
        </div>
      ))}
    </section>
  );
};

export default WhyChooseUs;
